export async function makeSureVueIsLoaded() {
    if (!window.Vue) {
        window.Vue = (await import("../_vendor/js/vue.min.js")).default
    }
}
